import { render, staticRenderFns } from "./adminHeaders.vue?vue&type=template&id=57f6326a&scoped=true&"
import script from "./adminHeaders.vue?vue&type=script&lang=js&"
export * from "./adminHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f6326a",
  null
  
)

export default component.exports